export function isValidTelegram(value) {
  const t = String(value || "").trim();
  if (!t || t.length > 64) return false;

  const digitsOnly = t.replace(/\D/g, "");
  const looksLikePhone =
    /^[+\d\s().\-]+$/.test(t) &&
    digitsOnly.length >= 8 &&
    digitsOnly.length <= 15;

  if (looksLikePhone) return true;

  const handle = t.startsWith("@") ? t.slice(1) : t;
  return /^[a-zA-Z0-9_]{5,32}$/.test(handle);
}
